import { Component, OnInit, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoginNeededModalComponent } from 'src/app/+shared/components/modals/login-needed-modal.component/login-needed-modal.component';
import { PaymentRejectedModalComponent } from 'src/app/+shared/components/modals/payment-rejected-modal.component/payment-rejected-modal.component';
import { RequestSignoutModalComponent } from 'src/app/+shared/components/modals/request-signout-modal.component/request-signout-modal.component';
import { OrderService, PlayerService } from 'src/app/services';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit
{
    public name: string;
    public isExpired = false;

    private readonly router: Router;
    private readonly orderService: OrderService;
    private readonly playerService: PlayerService;
    private readonly activatedRoute: ActivatedRoute;
    private readonly titleService: Title;
    private readonly metaService: Meta;

    @ViewChild('orderExpiredModal', { static: true })
    public orderExpiredModal: PaymentRejectedModalComponent;

    @ViewChild('loginNeededModal', { static: true })
    public loginNeededModal: LoginNeededModalComponent;

    @ViewChild('requestSignoutModal', { static: true })
    public requestSignoutModal: RequestSignoutModalComponent;

    public constructor(
        activatedRoute: ActivatedRoute,
        router: Router,
        orderService: OrderService,
        playerService: PlayerService,
        titleService: Title,
        metaService: Meta,
        )
    {
        this.router = router;
        this.orderService = orderService;
        this.playerService = playerService;
        this.activatedRoute = activatedRoute;
        this.titleService = titleService;
        this.metaService = metaService;
    }

    public async ngOnInit(): Promise<void>
    {
        // On navigation end.
        this.router.events.subscribe((evt) =>
        {
            if (!(evt instanceof NavigationEnd))
            {
                return;
            }

            window.scrollTo(0, 0);

            if (typeof (<any>window).ga === 'function')
            {
                (<any>window).ga('set', 'page', evt.urlAfterRedirects);
                (<any>window).ga('send', 'pageview');
            }

            this.setTitle();
        });

        this.playerService.onAuthorizationExpirationNotify.subscribe(() =>
        {
            this.loginNeededModal.open(false);
        });

        this.playerService.onAuthorizationNeededNotification.subscribe((bool) =>
        {
            this.isExpired = true;
            this.loginNeededModal.open(false);
        });

        /**
         * When a user actively clicks signout button, prompt user for confirmation hereof.
         */
        this.playerService.onRequestSignout.subscribe(async () => {

            const order = await this.orderService.getOrder(false);

            if (order == null || (order.Shares.length === 0 && order.TicketPackageInstances.length === 0))
            {
                this.playerService.signOut({ reroute: true, preserveOrder: false });
                return;
            }

            this.requestSignoutModal.open();
        });


        await this.initOrder();
    }

    private setTitle(): void
    {
        let snapshot = this.activatedRoute.snapshot;
        let title = 'Klasselotteriet';
        do
        {
            title = snapshot.data.title || title;
            if(snapshot && snapshot.data && snapshot.data.description){
                this.metaService.updateTag({ name: 'description', content: snapshot.data.description });
            }
            else{
                this.metaService.updateTag({ name: 'description', content:'' });
            }
        }
        while (snapshot = snapshot.firstChild);

        this.titleService.setTitle(title);

    
    }

    private async initOrder(): Promise<void> 
    {
        this.orderService.initOrderSustainLoop();
    }
}
